<template>
  <button
    @click="clickBtn"
    @keydown.enter="enterBtn"
    class="basicbutton"
    :class="[fontcolor, bgcolor, border, boxshadow, boxsize]"
    :disabled="disabled"
  >
    <slot name="before-icon"></slot>
    <slot name="btnname"></slot>
    <slot name="after-icon"></slot>
  </button>
</template>
<script>
export default {
  props: {
    /**
     * @description 폰트 색상
     */
    fontcolor: {
      type: String,
      default: '', // ft-black
      required: false
    },
    /**
     * @description 버튼 배경색상
     */
    bgcolor: {
      type: String,
      default: '', // bg-white
      required: false
    },
    /**
     * @description 버튼 disabled
     */
    disabled: {
      type: Boolean,
      default: false,
      required: false
    },
    /**
     * @description Border
     */
    border: {
      type: String,
      default: '',
      required: false
    },
    /**
     * @description 버튼 그림자
     */
    boxshadow: {
      type: String,
      default: '',
      required: false
    },
    /**
     * @description 버튼 사이즈
     */
    boxsize: {
      type: String,
      default: 'lg', // lg md sm
      required: false
    }
  },
  emits: ['click-btn', 'enter-btn'],
  methods: {
    clickBtn() {
      this.$emit('click-btn');
    },
    enterBtn() {
      this.$emit('enter-btn');
    }
  },
  mounted() {},
  created() {}
};
</script>
<style scoped src="@/assets/css/basicbutton/basicbutton.css"></style>
